export { default as App } from './App'
export { default as Main } from './Main'
export { default as Login } from './Login'
export { default as LoginCreatePassword } from './LoginCreatePassword'
export { default as LoginResetPasswordRequest } from './LoginResetPasswordRequest'
export { default as UnsupportedBrowser } from './UnsupportedBrowser'
export { default as RedirectNotice } from './RedirectNotice'
// main routes
export { default as Dashboard } from './Dashboard'
export { default as FilesUpload } from './FilesUpload'
export { default as Home } from './Home'
export { default as ObjectRedirect } from './ObjectRedirect'
export { default as WhatsAppMessage } from './WhatsAppMessage'
export { default as Request } from './Request'
export { default as Requests } from './Requests'

export { default as EmployeeList } from './messageplus/EmployeeList'
export { default as EmployeeDetail } from './messageplus/EmployeeDetail'
export { default as EmployeeOverview } from './messageplus/EmployeeOverview'
export { default as EmployerGroupEmployeeOverview } from './messageplus/EmployerGroupEmployeeOverview'
export { default as EmployerSMS } from './messageplus/EmployerSMS'
export { default as EmployerGroupSMS } from './messageplus/EmployerGroupSMS'
export { default as EmployerBulkMessage } from './messageplus/EmployerBulkMessage'
export { default as EmployerWhatsApp } from './messageplus/EmployerWhatsApp'
export { default as EmployerRelatedMessages } from './messageplus/EmployerRelatedMessages'
export { default as EmployerBulkSMSAudience } from './messageplus/EmployerBulkSMSAudience'



// WEBPACK FOOTER //
// ./src/containers/index.js